import ActionPanel from '../components/ActionPanel.jsx';
import { ExternalLinkIcon } from '../components/icons.jsx';
import ScreenHeader from '../components/ScreenHeader.jsx';
import { HELP_PATH } from '../navigation/paths.js';

// The FAQs section — the app's Menu/FaqLinks.js as a web page: the same four
// links to the Ideal Heating FAQ pages, opened in a new tab. As with the videos,
// the app keeps these URLs inline, so they are restated here and are the one
// thing to keep in step with it.
const faqs = [
  {
    title: 'Halo installation',
    href: 'https://idealheating.com/support/faqs/halo-installation',
  },
  {
    title: 'Using your thermostat',
    href: 'https://idealheating.com/support/faqs/using-your-halo-thermostat',
  },
  {
    title: 'Halo & virtual assistants',
    href: 'https://idealheating.com/support/faqs/halo-alexa-google-home',
  },
  {
    title: 'Using the Halo app',
    href: 'https://idealheating.com/support/faqs/using-the-halo-app',
  },
];

export default function FaqLinksScreen() {
  return (
    <main className="app-shell screen">
      <ScreenHeader
        title="FAQs"
        sub="The following links will take you to the Ideal Heating FAQs web page"
        backTo={HELP_PATH}
        backLabel="Help"
      />
      <nav className="action-panel-list" aria-label="FAQ pages">
        {faqs.map(({ title, href }) => (
          <ActionPanel
            key={href}
            href={href}
            title={title}
            actionIcon={<ExternalLinkIcon />}
          />
        ))}
      </nav>
    </main>
  );
}
